import React, { useCallback, useMemo, useEffect, useRef, useState } from 'react';
import { Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import IconBackGround from '../../common/iconBackGround';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { GAME_SPEED_TYPES } from '../../../core/constants/gameConstants';
import { gameStore } from '../../../store/gameStore';
import { isMobile } from '../../../core/helpers/isMobile';
import { reaction } from 'mobx';

const GameSpeed = observer(({ x = 0, y = 0 }) => {
  const { gameSpeedType, setGameSpeedType } = bettingPartStore;
  const { standardSpeed, fastSpeed, turboSpeed } = getGameImages();

  const [pendingSpeed, setPendingSpeed] = useState(null);

  const effectiveSpeedType = pendingSpeed !== null ? pendingSpeed : gameSpeedType;

  const handleChangeGameSpeed = useCallback(() => {
    if (!gameStore.isSpinButtonHolded) {
      let nextSpeed;
      if (effectiveSpeedType === GAME_SPEED_TYPES.standard) {
        nextSpeed = GAME_SPEED_TYPES.fast;
      } else if (effectiveSpeedType === GAME_SPEED_TYPES.fast) {
        nextSpeed = GAME_SPEED_TYPES.turbo;
      } else {
        nextSpeed = GAME_SPEED_TYPES.standard;
      }
      setPendingSpeed(nextSpeed);

      if (!gameStore.isReelsRotating) {
        setGameSpeedType(nextSpeed);
        setPendingSpeed(null);
      }
    }
  }, [effectiveSpeedType, setGameSpeedType]);

  useEffect(() => {
    const disposer = reaction(
      () => gameStore.isReelsRotating,
      (isRotating) => {
        if (!isRotating && !gameStore.isSpinButtonHolded && pendingSpeed !== null) {
          setGameSpeedType(pendingSpeed);
          setPendingSpeed(null);
        }
      }
    );
    return () => disposer();
  }, [pendingSpeed, setGameSpeedType]);

  const gameSpeedIcons = useMemo(
    () => ({
      [GAME_SPEED_TYPES.standard]: standardSpeed,
      [GAME_SPEED_TYPES.fast]: fastSpeed,
      [GAME_SPEED_TYPES.turbo]: turboSpeed,
    }),
    [standardSpeed, fastSpeed, turboSpeed]
  );

  const lastSpeedType = useRef(effectiveSpeedType);
  useEffect(() => {
    lastSpeedType.current = effectiveSpeedType;
  }, [effectiveSpeedType]);

  const displaySpeedType =
    gameStore.isSpinButtonHolded && effectiveSpeedType === GAME_SPEED_TYPES.turbo
      ? lastSpeedType.current
      : effectiveSpeedType;

  return (
    <IconBackGround y={y} x={x} handleSelect={handleChangeGameSpeed} hasSelectedState={false}>
      <Sprite
        texture={gameSpeedIcons[displaySpeedType]}
        anchor={0.5}
        scale={isMobile() ? 0.77 : 0.5}
      />
    </IconBackGround>
  );
});

export default GameSpeed;
